import React, { useState, useEffect, useRef } from 'react';
import './App.css';

const App = () => {
  // ========== ETATS GENERAUX ==========
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeSection, setActiveSection] = useState('dashboard');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [showNotification, setShowNotification] = useState({ show: false, message: '', type: 'info' });
  const [confetti, setConfetti] = useState([]);
  const [isMusicPlaying, setIsMusicPlaying] = useState(false);
  const audioRef = useRef(null);
  
  // ========== NOTIFICATIONS ==========
  const [notifications, setNotifications] = useState([]);
  const [tasksDueSoon, setTasksDueSoon] = useState([]);
  const [weeklyChartData, setWeeklyChartData] = useState({
    study: [2, 3, 1, 4, 2, 5, 3],
    focus: [1, 2, 0, 3, 1, 4, 2],
    tasks: [2, 1, 3, 2, 4, 1, 3]
  });
  const [dailyTip, setDailyTip] = useState('');
  
  const tips = [
    "Eteignez vos notifications pendant 2h - votre cerveau vous remerciera !",
    "Rangez votre telephone dans une autre piece pendant vos revisions",
    "25min de focus = 5min de pause - La regle d'or de la productivite",
    "Vous etes plus fort que l'algorithme ! Restez concentre !",
    "Chaque minute sans distraction est une victoire",
    "Le temps perdu sur les reseaux ne revient jamais",
    "Votre future reussite depend de vos choix aujourd'hui",
    "Les etudiants qui limitent les reseaux reussissent 40% mieux"
  ];
  
  // ========== GAMIFICATION ==========
  const [userLevel, setUserLevel] = useState(1);
  const [userXP, setUserXP] = useState(0);
  const [streak, setStreak] = useState(0);
  const [coins, setCoins] = useState(0);
  const [badges, setBadges] = useState([]);
  const [lastStudyDate, setLastStudyDate] = useState(null);
  const [unlockedRewards, setUnlockedRewards] = useState([]);
  
  // ========== MINI-JEUX ==========
  const [memoryCards, setMemoryCards] = useState([]);
  const [flippedIndexes, setFlippedIndexes] = useState([]);
  const [matchedPairs, setMatchedPairs] = useState([]);
  const [gameScore, setGameScore] = useState(0);
  const [quizQuestions, setQuizQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [quizScore, setQuizScore] = useState(0);
  const [quizFinished, setQuizFinished] = useState(false);
  const [reactionTime, setReactionTime] = useState(null);
  const [reactionActive, setReactionActive] = useState(false);
  const [reactionStartTime, setReactionStartTime] = useState(null);
  
  const memoryItems = ['BOOK', 'GRAD', 'PEN', 'IDEA', 'TARGET', 'TROPHY', 'STAR', 'FIRE'];
  
  // ========== TACHES ==========
  const [tasks, setTasks] = useState([
    { id: 1, text: "Rendre projet Java", completed: false, deadline: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(), priority: "high", xpReward: 50 },
    { id: 2, text: "Preparer examen Python", completed: false, deadline: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(), priority: "medium", xpReward: 30 },
    { id: 3, text: "Reviser Algorithmes", completed: true, deadline: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), priority: "low", xpReward: 20 },
  ]);
  const [newTask, setNewTask] = useState('');
  const [newTaskDeadline, setNewTaskDeadline] = useState('');
  
  // ========== PLANNING ==========
  const [studyPlan, setStudyPlan] = useState({
    monday: { subject: '', hours: 0 },
    tuesday: { subject: '', hours: 0 },
    wednesday: { subject: '', hours: 0 },
    thursday: { subject: '', hours: 0 },
    friday: { subject: '', hours: 0 },
    saturday: { subject: '', hours: 0 },
    sunday: { subject: '', hours: 0 }
  });
  
  // ========== POMODORO ==========
  const [focusMode, setFocusMode] = useState({ active: false, timeLeft: 25 * 60, type: 'work' });
  const [pomodoroSettings, setPomodoroSettings] = useState({ work: 25, shortBreak: 5, longBreak: 15, sessionsBeforeLong: 4 });
  const [completedSessions, setCompletedSessions] = useState(0);
  const timerRef = useRef(null);
  
  // ========== SOMMEIL ==========
  const [sleepTime, setSleepTime] = useState('23:00');
  const [showSleepReminder, setShowSleepReminder] = useState(false);
  
  // ========== ANALYTIQUE ==========
  const [activityHeatmap, setActivityHeatmap] = useState({});
  const [studyTimeBySubject, setStudyTimeBySubject] = useState({});
  
  // ========== NOTES ==========
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState('');
  const [noteCategory, setNoteCategory] = useState('Cours');
  const [noteSearch, setNoteSearch] = useState('');
  
  // ========== RAPPELS ==========
  const [reminders, setReminders] = useState([]);
  const [newReminder, setNewReminder] = useState({ title: '', time: '' });
  const [pendingReminder, setPendingReminder] = useState(null);
  const [countdownAlert, setCountdownAlert] = useState({ show: false, message: '', seconds: 0 });
  const countdownIntervalRef = useRef(null);
  
  // ========== OBJECTIFS ==========
  const [dailyGoals, setDailyGoals] = useState({ studyHours: 2, tasksCompleted: 3, focusSessions: 4 });
  const [weeklyGoals, setWeeklyGoals] = useState({ studyHours: 15, tasksCompleted: 20, focusSessions: 25 });
  const [goalProgress, setGoalProgress] = useState({ study: 0, tasks: 0, focus: 0 });
  
  // ========== DEFIS QUOTIDIENS ==========
  const [dailyChallenges, setDailyChallenges] = useState([
    { id: 'noSocial', title: '2h sans reseaux', progress: 0, target: 120, completed: false, xpReward: 100 },
    { id: 'studyTime', title: '2h d\'etude', progress: 0, target: 120, completed: false, xpReward: 80 },
    { id: 'tasks', title: '3 taches completees', progress: 0, target: 3, completed: false, xpReward: 60 },
    { id: 'pomodoro', title: '4 sessions Pomodoro', progress: 0, target: 4, completed: false, xpReward: 100 }
  ]);
  
  // ========== COMPTE A REBOURS EXAMEN - MULTI-EXAMENS ==========
  const [exams, setExams] = useState([
    { id: 1, name: "Examen Java", date: "2026-06-15", color: "#89CFF0", completed: false },
    { id: 2, name: "Examen Python", date: "2026-06-20", color: "#f5a0c7", completed: false },
    { id: 3, name: "Examen Audit", date: "2026-06-25", color: "#10b981", completed: false }
  ]);
  const [newExamName, setNewExamName] = useState('');
  const [newExamDate, setNewExamDate] = useState('');
  const [showAddExam, setShowAddExam] = useState(false);
  const [examTimeLeft, setExamTimeLeft] = useState({});
  const [editingExamId, setEditingExamId] = useState(null);
  const [editExamName, setEditExamName] = useState('');
  const [editExamDate, setEditExamDate] = useState('');
  
  // ========== RESSOURCES PAR COURS ==========
  const [selectedSubject, setSelectedSubject] = useState('Java');
  const [selectedResourceType, setSelectedResourceType] = useState('cours');
  
  const subjects = ['Java', 'Python', 'JavaScript', 'Economics', 'Audit', 'Maths', 'Physique', 'Chimie', 'Anglais', 'Francais', 'Histoire', 'Geographie'];
  
  // ========== PROGRESS ==========
  const [progressData, setProgressData] = useState({
    tasksCompleted: 0,
    studyHours: 0,
    focusSessions: 0
  });
  
  // Ressources
  const resources = {
    Java: { cours: [{ name: "OpenClassrooms - Java", url: "#" }], exercices: [], livres: [], videos: [] },
    Python: { cours: [{ name: "OpenClassrooms - Python", url: "#" }], exercices: [], livres: [], videos: [] }
  };
  
  // ========== COMPTE A REBOURS POUR CHAQUE EXAMEN ==========
  useEffect(() => {
    const updateAllCountdowns = () => {
      const newTimeLeft = {};
      const now = new Date();
      
      exams.forEach(exam => {
        if (!exam.completed) {
          const examDateObj = new Date(exam.date);
          const diff = examDateObj - now;
          
          if (diff <= 0) {
            newTimeLeft[exam.id] = { days: 0, hours: 0, minutes: 0, seconds: 0, isPassed: true };
          } else {
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);
            newTimeLeft[exam.id] = { days, hours, minutes, seconds, isPassed: false };
          }
        }
      });
      
      setExamTimeLeft(newTimeLeft);
    };
    
    updateAllCountdowns();
    const interval = setInterval(updateAllCountdowns, 1000);
    return () => clearInterval(interval);
  }, [exams]);
  
  // ========== INITIALISATION ==========
  useEffect(() => {
    loadAllData();
    const totalHours = Object.values(studyPlan).reduce((sum, day) => sum + (parseFloat(day.hours) || 0), 0);
    setProgressData(prev => ({ ...prev, studyHours: totalHours }));
    
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    
    const today = new Date().toDateString();
    const savedTipDate = localStorage.getItem('tip_date');
    if (savedTipDate !== today) {
      const randomTip = tips[Math.floor(Math.random() * tips.length)];
      setDailyTip(randomTip);
      localStorage.setItem('tip_date', today);
      localStorage.setItem('daily_tip', randomTip);
    } else {
      const savedTip = localStorage.getItem('daily_tip');
      if (savedTip) setDailyTip(savedTip);
    }
    
    checkDailyReset();
    initMemoryGame();
    initQuiz();
    
    return () => {
      clearInterval(timer);
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);
  
  // Sauvegarde auto
  useEffect(() => {
    saveAllData();
    updateGoalProgress();
    updateStudyTimeBySubject();
  }, [tasks, progressData, studyPlan, notes, reminders, userLevel, userXP, streak, coins, badges, exams]);
  
  // Timer Pomodoro
  useEffect(() => {
    if (focusMode.active && focusMode.timeLeft > 0) {
      timerRef.current = setInterval(() => {
        setFocusMode(prev => ({ ...prev, timeLeft: prev.timeLeft - 1 }));
      }, 1000);
    } else if (focusMode.active && focusMode.timeLeft === 0) {
      clearInterval(timerRef.current);
      
      if (focusMode.type === 'work') {
        addNotification('Session terminee! +25 XP', 'success');
        addXP(25);
        const newSessions = completedSessions + 1;
        setCompletedSessions(newSessions);
        updateChallengeProgress('pomodoro', 1);
        
        if (newSessions % pomodoroSettings.sessionsBeforeLong === 0) {
          addNotification('Longue pause de 15 minutes !', 'info');
          setFocusMode({ active: true, timeLeft: pomodoroSettings.longBreak * 60, type: 'longBreak' });
        } else {
          addNotification('Pause de 5 minutes !', 'info');
          setFocusMode({ active: true, timeLeft: pomodoroSettings.shortBreak * 60, type: 'break' });
        }
        triggerConfetti();
        setProgressData(prev => ({ ...prev, focusSessions: prev.focusSessions + 1 }));
        recordActivity();
      } else {
        addNotification('Pause terminee! Reprenez le travail !', 'info');
        setFocusMode({ active: true, timeLeft: pomodoroSettings.work * 60, type: 'work' });
      }
    }
    return () => clearInterval(timerRef.current);
  }, [focusMode.active, focusMode.timeLeft, focusMode.type]);
  
  // Verification des taches urgentes
  useEffect(() => {
    const checkDueTasks = () => {
      const now = new Date();
      const dueTasks = tasks.filter(task => {
        if (!task.deadline || task.completed) return false;
        const deadline = new Date(task.deadline);
        const timeDiff = deadline - now;
        const daysLeft = timeDiff / (1000 * 60 * 60 * 24);
        return daysLeft <= 2 && daysLeft > 0;
      });
      setTasksDueSoon(dueTasks);
    };
    checkDueTasks();
    const interval = setInterval(checkDueTasks, 3600000);
    return () => clearInterval(interval);
  }, [tasks]);
  
  // Sommeil
  useEffect(() => {
    const checkSleepTime = setInterval(() => {
      const now = new Date();
      const currentTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
      if (currentTime === sleepTime) {
        addNotification('Time to rest. Avoid using your phone. Good night!', 'sleep');
        setShowSleepReminder(true);
        setTimeout(() => setShowSleepReminder(false), 10000);
      }
    }, 60000);
    return () => clearInterval(checkSleepTime);
  }, [sleepTime]);
  
  // Verification des rappels
  useEffect(() => {
    const checkReminders = setInterval(() => {
      const now = new Date();
      const currentTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
      
      reminders.forEach(reminder => {
        const [reminderHour, reminderMinute] = reminder.time.split(':');
        const reminderDate = new Date();
        reminderDate.setHours(parseInt(reminderHour), parseInt(reminderMinute), 0, 0);
        
        const timeDiff = reminderDate - now;
        const minutesDiff = Math.floor(timeDiff / 60000);
        
        if (minutesDiff === 1 && !pendingReminder && !countdownAlert.show) {
          setPendingReminder(reminder);
          addNotification(`Rappel dans 1 minute : "${reminder.title}"`, 'warning');
          playAlertSound();
        }
        
        if (reminder.time === currentTime) {
          if (pendingReminder?.id === reminder.id) setPendingReminder(null);
          addNotification(`Rappel : ${reminder.title}`, 'reminder');
          startCountdownAlert(reminder.title);
          playAlertSound();
        }
      });
    }, 1000);
    
    return () => clearInterval(checkReminders);
  }, [reminders, pendingReminder, countdownAlert.show]);
  
  // ========== FONCTIONS JEUX ==========
  const initMemoryGame = () => {
    const doubled = [...memoryItems, ...memoryItems];
    const shuffled = doubled.sort(() => Math.random() - 0.5);
    setMemoryCards(shuffled.map((item, index) => ({ id: index, value: item, flipped: false, matched: false })));
    setFlippedIndexes([]);
    setMatchedPairs([]);
    setGameScore(0);
  };
  
  const handleCardClick = (index) => {
    if (flippedIndexes.length === 2) return;
    if (memoryCards[index].flipped || memoryCards[index].matched) return;
    
    const newCards = [...memoryCards];
    newCards[index].flipped = true;
    setMemoryCards(newCards);
    
    const newFlipped = [...flippedIndexes, index];
    setFlippedIndexes(newFlipped);
    
    if (newFlipped.length === 2) {
      const card1 = memoryCards[newFlipped[0]];
      const card2 = memoryCards[newFlipped[1]];
      
      if (card1.value === card2.value) {
        setTimeout(() => {
          const updatedCards = [...memoryCards];
          updatedCards[newFlipped[0]].matched = true;
          updatedCards[newFlipped[1]].matched = true;
          updatedCards[newFlipped[0]].flipped = false;
          updatedCards[newFlipped[1]].flipped = false;
          setMemoryCards(updatedCards);
          setFlippedIndexes([]);
          setMatchedPairs([...matchedPairs, card1.value]);
          setGameScore(gameScore + 10);
          addXP(5);
          addNotification('+5 XP ! Bonne memoire !', 'success');
        }, 500);
      } else {
        setTimeout(() => {
          const resetCards = [...memoryCards];
          resetCards[newFlipped[0]].flipped = false;
          resetCards[newFlipped[1]].flipped = false;
          setMemoryCards(resetCards);
          setFlippedIndexes([]);
        }, 1000);
      }
    }
  };
  
  const initQuiz = () => {
    setQuizQuestions([
      { question: "Quelle est la technique de productivite qui alterne 25min de travail et 5min de pause ?", options: ["GTD", "Pomodoro", "Eisenhower", "Kanban"], correct: 1 },
      { question: "Combien de temps faut-il en moyenne pour retrouver sa concentration apres une interruption ?", options: ["5 min", "15 min", "23 min", "30 min"], correct: 2 },
      { question: "Quel est le meilleur moment de la journee pour etudier selon les neurosciences ?", options: ["Le matin", "L'apres-midi", "Le soir", "La nuit"], correct: 0 },
      { question: "Combien d'heures de sommeil sont recommandees pour un etudiant ?", options: ["5-6h", "6-7h", "7-9h", "9-10h"], correct: 2 },
      { question: "Quel pourcentage de reussite en plus apporte la prise de notes manuscrites ?", options: ["10%", "25%", "40%", "60%"], correct: 2 }
    ]);
    setCurrentQuestion(0);
    setQuizScore(0);
    setQuizFinished(false);
  };
  
  const handleAnswer = (selectedIndex) => {
    if (quizFinished) return;
    const isCorrect = selectedIndex === quizQuestions[currentQuestion].correct;
    if (isCorrect) {
      setQuizScore(quizScore + 20);
      addXP(10);
      addNotification('Bonne reponse ! +10 XP', 'success');
      triggerConfetti();
    }
    
    if (currentQuestion + 1 < quizQuestions.length) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setQuizFinished(true);
      const bonus = quizScore + (isCorrect ? 20 : 0);
      addNotification(`Quiz termine ! Score: ${bonus}/${quizQuestions.length * 20} XP`, 'levelup');
      addXP(bonus);
      triggerConfetti();
    }
  };
  
  const startReactionGame = () => {
    setReactionActive(true);
    setReactionTime(null);
    const delay = Math.random() * 5000 + 1000;
    setTimeout(() => {
      setReactionStartTime(Date.now());
      setReactionActive('click');
    }, delay);
  };
  
  const handleReactionClick = () => {
    if (reactionActive === 'click') {
      const reactionMs = Date.now() - reactionStartTime;
      setReactionTime(reactionMs);
      setReactionActive(false);
      const xpGain = Math.max(10, Math.floor(500 / reactionMs) * 5);
      addXP(xpGain);
      addNotification(`Temps de reaction: ${reactionMs}ms ! +${xpGain} XP`, 'success');
      triggerConfetti();
    } else if (reactionActive === true) {
      addNotification('Trop tot ! Attendez le signal vert !', 'warning');
      setReactionActive(false);
    }
  };
  
  // ========== FONCTIONS PRINCIPALES ==========
  const checkDailyReset = () => {
    const lastReset = localStorage.getItem('last_challenge_reset');
    const today = new Date().toDateString();
    if (lastReset !== today) {
      setDailyChallenges(prev => prev.map(c => ({ ...c, progress: 0, completed: false })));
      localStorage.setItem('last_challenge_reset', today);
      addNotification('Nouveaux defis quotidiens disponibles !', 'info');
    }
  };
  
  const saveAllData = () => {
    const allData = { tasks, studyPlan, progressData, sleepTime, notes, reminders, userLevel, userXP, streak, coins, badges, activityHeatmap, unlockedRewards, dailyGoals, weeklyGoals, pomodoroSettings, exams };
    localStorage.setItem('smart_student_all_data', JSON.stringify(allData));
  };
  
  const loadAllData = () => {
    const savedData = localStorage.getItem('smart_student_all_data');
    if (savedData) {
      const data = JSON.parse(savedData);
      setTasks(data.tasks || []);
      setStudyPlan(data.studyPlan || studyPlan);
      setProgressData(data.progressData || progressData);
      setSleepTime(data.sleepTime || '23:00');
      setNotes(data.notes || []);
      setReminders(data.reminders || []);
      setUserLevel(data.userLevel || 1);
      setUserXP(data.userXP || 0);
      setStreak(data.streak || 0);
      setCoins(data.coins || 0);
      setBadges(data.badges || []);
      setActivityHeatmap(data.activityHeatmap || {});
      setUnlockedRewards(data.unlockedRewards || []);
      setDailyGoals(data.dailyGoals || dailyGoals);
      setWeeklyGoals(data.weeklyGoals || weeklyGoals);
      if (data.pomodoroSettings) setPomodoroSettings(data.pomodoroSettings);
      if (data.exams) setExams(data.exams);
    }
  };
  
  const recordActivity = () => {
    const today = new Date().toDateString();
    setActivityHeatmap(prev => ({ ...prev, [today]: (prev[today] || 0) + 1 }));
  };
  
  const updateStudyTimeBySubject = () => {
    const subjectHours = {};
    Object.values(studyPlan).forEach(day => {
      if (day.subject && day.hours > 0) {
        subjectHours[day.subject] = (subjectHours[day.subject] || 0) + day.hours;
      }
    });
    setStudyTimeBySubject(subjectHours);
  };
  
  const updateGoalProgress = () => {
    setGoalProgress({
      study: Math.min((progressData.studyHours / weeklyGoals.studyHours) * 100, 100),
      tasks: Math.min((progressData.tasksCompleted / weeklyGoals.tasksCompleted) * 100, 100),
      focus: Math.min((progressData.focusSessions / weeklyGoals.focusSessions) * 100, 100)
    });
  };
  
  const addXP = (amount) => {
    let newXP = userXP + amount;
    let newLevel = userLevel;
    const xpNeeded = userLevel * 100;
    if (newXP >= xpNeeded) {
      newLevel++;
      newXP -= xpNeeded;
      addNotification(`Niveau ${newLevel} atteint! +50 COINS`, 'levelup');
      setCoins(coins + 50);
      triggerConfetti();
    }
    setUserXP(newXP);
    setUserLevel(newLevel);
  };
  
  const addNotification = (message, type) => {
    setShowNotification({ show: true, message, type });
    setTimeout(() => setShowNotification({ show: false, message: '', type: 'info' }), 3000);
    
    const newNotification = {
      id: Date.now(),
      message: message,
      type: type,
      read: false,
      timestamp: new Date()
    };
    setNotifications(prev => [newNotification, ...prev].slice(0, 20));
  };
  
  const triggerConfetti = () => {
    const confettiChars = ['*', '.', '+', '~', 'o', 'O', '0', '#'];
    const newConfetti = [];
    for (let i = 0; i < 100; i++) {
      newConfetti.push({
        id: i,
        x: Math.random() * window.innerWidth,
        y: -20,
        vx: (Math.random() - 0.5) * 6,
        vy: Math.random() * 12 + 8,
        char: confettiChars[Math.floor(Math.random() * confettiChars.length)],
        size: Math.random() * 30 + 20
      });
    }
    setConfetti(newConfetti);
    const interval = setInterval(() => {
      setConfetti(prev => {
        const updated = prev.map(c => ({ ...c, x: c.x + c.vx, y: c.y + c.vy }));
        return updated.filter(c => c.y < window.innerHeight);
      });
    }, 50);
    setTimeout(() => clearInterval(interval), 4000);
    setTimeout(() => setConfetti([]), 5000);
  };
  
  const toggleMusic = () => {
    if (audioRef.current) {
      if (isMusicPlaying) audioRef.current.pause();
      else audioRef.current.play().catch(e => console.log("Audio play failed:", e));
      setIsMusicPlaying(!isMusicPlaying);
    }
  };
  
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  
  const startFocus = () => {
    if (focusMode.active) {
      clearInterval(timerRef.current);
      setFocusMode({ ...focusMode, active: false });
      addNotification('Mode Focus en pause', 'info');
    } else {
      setFocusMode({ ...focusMode, active: true });
      addNotification('Mode Focus active! +25 XP a la fin!', 'success');
    }
  };
  
  const resetFocus = () => {
    clearInterval(timerRef.current);
    setFocusMode({ active: false, timeLeft: pomodoroSettings.work * 60, type: 'work' });
    setCompletedSessions(0);
    addNotification('Minuteur reinitialise', 'info');
  };
  
  const addTask = () => {
    if (newTask.trim()) {
      const newTaskObj = {
        id: Date.now(),
        text: newTask,
        completed: false,
        deadline: newTaskDeadline,
        priority: "medium",
        xpReward: 20,
        createdAt: new Date().toISOString()
      };
      setTasks([...tasks, newTaskObj]);
      setNewTask('');
      setNewTaskDeadline('');
      addNotification(`Tache ajoutee: "${newTask}"`, 'success');
    }
  };
  
  const toggleTask = (id) => {
    setTasks(tasks.map(task => {
      if (task.id === id && !task.completed) {
        addNotification(`Tache completee! +${task.xpReward} XP`, 'success');
        addXP(task.xpReward);
        setProgressData(prev => ({ ...prev, tasksCompleted: prev.tasksCompleted + 1 }));
        updateChallengeProgress('tasks', 1);
        recordActivity();
        return { ...task, completed: true };
      }
      return task;
    }));
  };
  
  const deleteTask = (id) => {
    setTasks(tasks.filter(task => task.id !== id));
    addNotification('Tache supprimee', 'info');
  };
  
  const updateStudyDay = (day, field, value) => {
    setStudyPlan(prev => ({
      ...prev,
      [day]: { ...prev[day], [field]: value }
    }));
    const totalHours = Object.values(studyPlan).reduce((sum, day) => sum + (parseFloat(day.hours) || 0), 0);
    setProgressData(prev => ({ ...prev, studyHours: totalHours }));
    recordActivity();
  };
  
  const addNote = () => {
    if (newNote.trim()) {
      setNotes([...notes, { id: Date.now(), text: newNote, category: noteCategory, createdAt: new Date().toISOString() }]);
      setNewNote('');
      addNotification('Note ajoutee!', 'success');
    }
  };
  
  const deleteNote = (id) => {
    setNotes(notes.filter(n => n.id !== id));
    addNotification('Note supprimee', 'info');
  };
  
  const addReminder = () => {
    if (newReminder.title && newReminder.time) {
      setReminders([...reminders, { id: Date.now(), ...newReminder, createdAt: new Date().toISOString() }]);
      setNewReminder({ title: '', time: '' });
      addNotification(`Rappel ajoute: ${newReminder.title} a ${newReminder.time}`, 'success');
    }
  };
  
  const deleteReminder = (id) => {
    setReminders(reminders.filter(r => r.id !== id));
    addNotification('Rappel supprime', 'info');
  };
  
  // ========== FONCTIONS POUR LES ALERTES SONORES ==========
  const playAlertSound = () => {
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.frequency.value = 880;
      gainNode.gain.value = 0.3;
      oscillator.start();
      gainNode.gain.exponentialRampToValueAtTime(0.00001, audioContext.currentTime + 1);
      oscillator.stop(audioContext.currentTime + 1);
      setTimeout(() => audioContext.close(), 1000);
    } catch(e) {
      console.log("Son non supporte");
    }
  };
  
  const startCountdownAlert = (reminderTitle) => {
    setCountdownAlert({ show: true, message: reminderTitle, seconds: 10 });
    
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate([200, 100, 200]);
    }
    
    if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
    
    countdownIntervalRef.current = setInterval(() => {
      setCountdownAlert(prev => {
        if (prev.seconds <= 1) {
          clearInterval(countdownIntervalRef.current);
          return { show: false, message: '', seconds: 0 };
        }
        return { ...prev, seconds: prev.seconds - 1 };
      });
    }, 1000);
    
    setTimeout(() => {
      setCountdownAlert({ show: false, message: '', seconds: 0 });
      if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
    }, 10000);
  };
  
  const snoozeReminder = (reminderMessage) => {
    setCountdownAlert({ show: false, message: '', seconds: 0 });
    if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
    
    const snoozeTime = new Date();
    snoozeTime.setMinutes(snoozeTime.getMinutes() + 5);
    const snoozeHour = snoozeTime.getHours().toString().padStart(2, '0');
    const snoozeMinute = snoozeTime.getMinutes().toString().padStart(2, '0');
    
    setReminders(prev => [...prev, {
      id: Date.now(),
      title: `${reminderMessage} (rappel dans 5min)`,
      time: `${snoozeHour}:${snoozeMinute}`,
      createdAt: new Date().toISOString()
    }]);
    
    addNotification(`Rappel reporte a ${snoozeHour}:${snoozeMinute}`, 'info');
  };
  
  // ========== FONCTIONS POUR LES DEFIS ==========
  const updateChallengeProgress = (challengeId, increment) => {
    setDailyChallenges(prev => prev.map(challenge => {
      if (challenge.id === challengeId && !challenge.completed) {
        const newProgress = Math.min(challenge.progress + increment, challenge.target);
        const completed = newProgress >= challenge.target;
        if (completed) {
          addNotification(`Defi complete ! +${challenge.xpReward} XP`, 'levelup');
          addXP(challenge.xpReward);
          setBadges([...badges, { name: challenge.title, date: new Date() }]);
          triggerConfetti();
        }
        return { ...challenge, progress: newProgress, completed };
      }
      return challenge;
    }));
  };
  
  // ========== FONCTIONS POUR LES EXAMENS ==========
  const addExam = () => {
    if (newExamName.trim() && newExamDate) {
      const today = new Date();
      const examDateObj = new Date(newExamDate);
      today.setHours(0, 0, 0, 0);
      
      if (examDateObj < today) {
        addNotification('La date de l\'examen ne peut pas etre dans le passe !', 'warning');
        return;
      }
      
      const newExam = {
        id: Date.now(),
        name: newExamName,
        date: newExamDate,
        color: ['#89CFF0', '#f5a0c7', '#10b981', '#f59e0b', '#8b5cf6'][Math.floor(Math.random() * 5)],
        completed: false,
        createdAt: new Date().toISOString()
      };
      setExams([...exams, newExam]);
      setNewExamName('');
      setNewExamDate('');
      setShowAddExam(false);
      addNotification(`Examen "${newExamName}" ajoute avec succes !`, 'success');
      triggerConfetti();
      saveAllData();
    } else {
      addNotification('Veuillez remplir tous les champs (nom et date)', 'warning');
    }
  };
  
  const deleteExam = (id) => {
    const examToDelete = exams.find(e => e.id === id);
    setExams(exams.filter(e => e.id !== id));
    addNotification(`Examen "${examToDelete?.name}" supprime`, 'info');
    saveAllData();
  };
  
  const markExamCompleted = (id) => {
    const exam = exams.find(e => e.id === id);
    if (exam && !exam.completed) {
      setExams(exams.map(exam => 
        exam.id === id ? { ...exam, completed: true, completedAt: new Date().toISOString() } : exam
      ));
      addNotification(`Felicitations ! "${exam.name}" est termine ! +100 XP`, 'levelup');
      addXP(100);
      triggerConfetti();
      saveAllData();
    }
  };
  
  const startEditExam = (exam) => {
    setEditingExamId(exam.id);
    setEditExamName(exam.name);
    setEditExamDate(exam.date);
  };
  
  const saveEditExam = (id) => {
    setExams(exams.map(exam => 
      exam.id === id ? { ...exam, name: editExamName, date: editExamDate } : exam
    ));
    setEditingExamId(null);
    setEditExamName('');
    setEditExamDate('');
    addNotification('Examen modifie avec succes !', 'success');
    saveAllData();
  };
  
  const cancelEditExam = () => {
    setEditingExamId(null);
    setEditExamName('');
    setEditExamDate('');
  };
  
  const getExamStatus = (exam) => {
    const timeLeft = examTimeLeft[exam.id];
    if (!timeLeft) return { status: 'loading', message: '', class: '' };
    if (timeLeft.isPassed) return { status: 'passed', message: 'EXAMEN PASSE', class: 'status-passed' };
    if (timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes < 60) {
      return { status: 'urgent', message: 'URGENT - DANS MOINS D\'UNE HEURE !', class: 'status-urgent' };
    }
    if (timeLeft.days === 0 && timeLeft.hours < 24) {
      return { status: 'warning', message: 'C\'EST DEMAIN ! REVISEZ !', class: 'status-warning' };
    }
    if (timeLeft.days <= 7) {
      return { status: 'soon', message: `Plus que ${timeLeft.days} jours - Restez motive !`, class: 'status-soon' };
    }
    return { status: 'ok', message: '', class: 'status-ok' };
  };
  
  // ========== RENDU DES SECTIONS ==========
  const renderDashboard = () => {
    const totalTasks = tasks.length;
    const completedTasks = tasks.filter(t => t.completed).length;
    const completionRate = totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;
    const hour = currentTime.getHours();
    const greeting = hour < 12 ? "Bonjour" : hour < 18 ? "Bon apres-midi" : "Bonsoir";
    
    return (
      <div className="dashboard-container">
        <div className="dashboard-header">
          <div className="greeting-section">
            <h2>{greeting}, Champion !</h2>
            <p className="date-time">
              {currentTime.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
              <span className="time">{currentTime.toLocaleTimeString('fr-FR')}</span>
            </p>
          </div>
          <div className="streak-card-dashboard">
            <span className="streak-fire">🔥</span>
            <div>
              <div className="streak-number">{streak}</div>
              <div className="streak-label">jours de reussite</div>
            </div>
          </div>
        </div>
        
        <div className="anti-social-card">
          <span>💡</span>
          <div>
            <strong>Defi du moment :</strong> {dailyTip}
          </div>
        </div>
        
        {/* SECTION EXAMENS */}
        <div className="exams-countdown-section">
          <div className="exams-header">
            <div className="exams-title">
              <span>📅</span>
              <h3>Mes Examens</h3>
            </div>
            <button className="add-exam-btn" onClick={() => setShowAddExam(true)}>
              + Ajouter un examen
            </button>
          </div>
          
          {showAddExam && (
            <div className="add-exam-form">
              <input type="text" placeholder="Nom de l'examen" value={newExamName} onChange={(e) => setNewExamName(e.target.value)} className="neon-input" autoFocus />
              <input type="date" value={newExamDate} onChange={(e) => setNewExamDate(e.target.value)} className="neon-input" min={new Date().toISOString().split('T')[0]} />
              <button onClick={addExam} className="btn-primary">Ajouter</button>
              <button onClick={() => setShowAddExam(false)} className="btn-cancel">Annuler</button>
            </div>
          )}
          
          <div className="exams-list">
            {exams.length === 0 ? (
              <div className="no-exams">
                <span>📋</span>
                <p>Aucun examen pour le moment. Ajoutez vos examens !</p>
                <button onClick={() => setShowAddExam(true)} className="btn-primary">+ Ajouter un examen</button>
              </div>
            ) : (
              exams.map(exam => {
                const timeLeft = examTimeLeft[exam.id] || { days: 0, hours: 0, minutes: 0, seconds: 0 };
                const status = getExamStatus(exam);
                const isEditing = editingExamId === exam.id;
                
                return (
                  <div key={exam.id} className={`exam-card ${exam.completed ? 'completed' : ''}`} style={{ borderLeftColor: exam.color }}>
                    <div className="exam-header">
                      {!isEditing ? (
                        <div className="exam-info">
                          <span className="exam-name">{exam.name}</span>
                          <span className="exam-date">{new Date(exam.date).toLocaleDateString('fr-FR')}</span>
                        </div>
                      ) : (
                        <div className="exam-edit-form">
                          <input type="text" value={editExamName} onChange={(e) => setEditExamName(e.target.value)} className="neon-input small-input" />
                          <input type="date" value={editExamDate} onChange={(e) => setEditExamDate(e.target.value)} className="neon-input small-input" />
                          <button onClick={() => saveEditExam(exam.id)} className="save-edit-btn">💾</button>
                          <button onClick={cancelEditExam} className="cancel-edit-btn">✖</button>
                        </div>
                      )}
                      
                      <div className="exam-actions">
                        {!exam.completed && !isEditing && (
                          <>
                            <button onClick={() => startEditExam(exam)} className="exam-edit-btn" title="Modifier">✏️</button>
                            <button onClick={() => markExamCompleted(exam.id)} className="exam-complete-btn" title="Terminer">✅</button>
                          </>
                        )}
                        {!isEditing && (
                          <button onClick={() => deleteExam(exam.id)} className="exam-delete-btn" title="Supprimer">🗑️</button>
                        )}
                      </div>
                    </div>
                    
                    {!exam.completed && !isEditing && (
                      <>
                        <div className="exam-countdown">
                          <div className="countdown-item"><span className="countdown-number">{timeLeft.days}</span><span>Jours</span></div>
                          <div className="countdown-separator">:</div>
                          <div className="countdown-item"><span className="countdown-number">{timeLeft.hours}</span><span>Heures</span></div>
                          <div className="countdown-separator">:</div>
                          <div className="countdown-item"><span className="countdown-number">{timeLeft.minutes}</span><span>Minutes</span></div>
                          <div className="countdown-separator">:</div>
                          <div className="countdown-item"><span className="countdown-number">{timeLeft.seconds}</span><span>Secondes</span></div>
                        </div>
                        {status.message && <div className={`exam-status ${status.class}`}>{status.message}</div>}
                      </>
                    )}
                    
                    {exam.completed && <div className="exam-completed-badge">🏆 EXAMEN TERMINE ! +100 XP 🏆</div>}
                  </div>
                );
              })
            )}
          </div>
        </div>
        
        {/* Statistiques */}
        <div className="stats-grid-dashboard">
          <div className="stat-card-dashboard" style={{ background: 'linear-gradient(135deg, #89CFF0, #6bb5e0)' }}>
            <span>✅</span>
            <div><div className="stat-value">{completedTasks}/{totalTasks}</div><div>Taches completees</div></div>
            <div className="stat-progress"><div className="stat-progress-fill" style={{ width: `${completionRate}%` }}></div></div>
          </div>
          <div className="stat-card-dashboard" style={{ background: 'linear-gradient(135deg, #f5a0c7, #f0b8d4)' }}>
            <span>📚</span>
            <div><div className="stat-value">{progressData.studyHours}h</div><div>Heures d'etude</div></div>
          </div>
          <div className="stat-card-dashboard" style={{ background: 'linear-gradient(135deg, #89CFF0, #6bb5e0)' }}>
            <span>🎯</span>
            <div><div className="stat-value">{progressData.focusSessions}</div><div>Sessions Focus</div></div>
          </div>
          <div className="stat-card-dashboard" style={{ background: 'linear-gradient(135deg, #f5a0c7, #f0b8d4)' }}>
            <span>⭐</span>
            <div><div className="stat-value">{userXP}</div><div>XP accumules</div></div>
          </div>
        </div>
        
        {/* Niveau */}
        <div className="level-card-dashboard">
          <div className="level-info-dashboard">
            <div className="level-icon">🏆</div>
            <div>
              <div className="level-title">Niveau {userLevel}</div>
              <div className="level-xp">{userXP} / {userLevel * 100} XP</div>
            </div>
            <div className="coins-display">🪙 {coins}</div>
          </div>
          <div className="level-progress-bar"><div className="level-progress-fill" style={{ width: `${(userXP % 100)}%` }}></div></div>
          <div className="next-level">Prochain niveau: +{100 - (userXP % 100)} XP</div>
        </div>
        
        {/* Statistique des examens */}
        <div className="exams-stats">
          <div className="exam-stat-card"><span>📋</span><div><strong>{exams.length}</strong><small>Examens au total</small></div></div>
          <div className="exam-stat-card"><span>✅</span><div><strong>{exams.filter(e => e.completed).length}</strong><small>Examens termines</small></div></div>
          <div className="exam-stat-card"><span>⏳</span><div><strong>{exams.filter(e => !e.completed).length}</strong><small>Examens a venir</small></div></div>
        </div>
      </div>
    );
  };
  
  const renderGames = () => (
    <div className="games-container">
      <h2 className="section-title">Mini-Jeux Educatifs</h2>
      <p className="games-subtitle">Jouez, apprenez et gagnez de l'XP ! Mieux que les reseaux sociaux !</p>
      
      <div className="games-grid">
        <div className="game-card">
          <div className="game-header"><h3>Jeu de Memoire</h3></div>
          <p>Trouvez les paires ! Entrainez votre memoire visuelle.</p>
          <div className="memory-game">
            <div className="memory-grid">
              {memoryCards.map((card, index) => (
                <div key={card.id} className={`memory-card ${card.flipped || card.matched ? 'flipped' : ''} ${card.matched ? 'matched' : ''}`} onClick={() => handleCardClick(index)}>
                  {(card.flipped || card.matched) ? card.value : '?'}
                </div>
              ))}
            </div>
          </div>
          <div className="game-score">Score: {gameScore}</div>
          <button onClick={initMemoryGame} className="game-btn">Nouvelle partie</button>
        </div>
        
        <div className="game-card">
          <div className="game-header"><h3>Quiz Etudiant</h3></div>
          <p>Testez vos connaissances sur les methodes de travail !</p>
          {!quizFinished ? (
            <div className="quiz-container">
              <div className="quiz-question">{quizQuestions[currentQuestion]?.question}</div>
              <div className="quiz-options">
                {quizQuestions[currentQuestion]?.options.map((opt, idx) => (
                  <button key={idx} onClick={() => handleAnswer(idx)} className="quiz-option">{opt}</button>
                ))}
              </div>
              <div className="quiz-progress">Question {currentQuestion + 1}/{quizQuestions.length}</div>
            </div>
          ) : (
            <div className="quiz-result">
              <div className="quiz-score">Score: {quizScore}/{quizQuestions.length * 20} XP</div>
              <button onClick={initQuiz} className="game-btn">Rejouer</button>
            </div>
          )}
        </div>
        
        <div className="game-card">
          <div className="game-header"><h3>Reflexe Etudiant</h3></div>
          <p>Testez votre temps de reaction ! Cliquez des que le bouton devient VERT.</p>
          <div className="reaction-game">
            {!reactionActive && !reactionTime && <button onClick={startReactionGame} className="reaction-start">Commencer</button>}
            {reactionActive === 'click' && <button onClick={handleReactionClick} className="reaction-button green">CLIQUEZ MAINTENANT !</button>}
            {reactionActive === true && <button className="reaction-button red">Attendez le signal vert...</button>}
            {reactionTime && (
              <div className="reaction-result">
                <div className="reaction-time">{reactionTime} ms</div>
                <button onClick={startReactionGame} className="game-btn">Rejouer</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
  
  const renderTasks = () => (
    <div className="glass-card">
      <h2 className="section-title">Gestion des taches</h2>
      <div className="task-input-group">
        <input type="text" value={newTask} onChange={(e) => setNewTask(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && addTask()} placeholder="Nouvelle tache..." className="neon-input" />
        <input type="datetime-local" value={newTaskDeadline} onChange={(e) => setNewTaskDeadline(e.target.value)} className="neon-input" />
        <button onClick={addTask} className="btn-primary">+ Ajouter (+20 XP)</button>
      </div>
      <div className="tasks-list">
        {tasks.map(task => (
          <div key={task.id} className={`task-item ${task.completed ? 'completed' : ''}`}>
            <input type="checkbox" checked={task.completed} onChange={() => toggleTask(task.id)} />
            <span className="task-text">{task.text}</span>
            <span className="task-xp">+{task.xpReward} XP</span>
            {task.deadline && <span className="task-deadline">📅 {new Date(task.deadline).toLocaleDateString()}</span>}
            <button onClick={() => deleteTask(task.id)} className="delete-btn">🗑️</button>
          </div>
        ))}
      </div>
    </div>
  );
  
  const renderStudyPlanner = () => (
    <div className="glass-card">
      <h2 className="section-title">Planning d'etude</h2>
      <div className="study-grid">
        {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(day => (
          <div key={day} className="study-day-card">
            <h3>{day.charAt(0).toUpperCase() + day.slice(1)}</h3>
            <select value={studyPlan[day].subject} onChange={(e) => updateStudyDay(day, 'subject', e.target.value)} className="neon-select">
              <option value="">Selectionner</option>
              {subjects.map(sub => <option key={sub} value={sub}>{sub}</option>)}
            </select>
            <input type="number" value={studyPlan[day].hours} onChange={(e) => updateStudyDay(day, 'hours', Math.max(0, parseInt(e.target.value) || 0))} placeholder="Heures" min="0" max="12" className="neon-input" />
          </div>
        ))}
      </div>
      <div className="weekly-total">Total hebdomadaire: {progressData.studyHours} heures</div>
    </div>
  );
  
  const renderPomodoro = () => (
    <div className="glass-card pomodoro-container">
      <h2 className="section-title">Mode Focus - Pomodoro</h2>
      <div className="timer-wrapper">
        <div className="timer-circle">
          <div className="timer-time">{formatTime(focusMode.timeLeft)}</div>
          <div className="timer-type">{focusMode.type === 'work' ? 'Travail - Gagnez des XP !' : focusMode.type === 'break' ? 'Pause courte' : 'Pause longue'}</div>
        </div>
        <div className="timer-controls">
          <button onClick={startFocus} className={`focus-btn ${focusMode.active ? 'active' : ''}`}>{focusMode.active ? 'Pause' : 'Demarrer'}</button>
          <button onClick={resetFocus} className="focus-btn reset-btn">Reset</button>
        </div>
      </div>
      <div className="pomodoro-stats">
        <div className="pomodoro-stat">Sessions: {completedSessions}</div>
        <div className="pomodoro-stat">Total: {progressData.focusSessions}</div>
        <div className="pomodoro-stat">Temps: {Math.floor(progressData.focusSessions * 120 / 60)}h</div>
      </div>
    </div>
  );
  
  const renderSleepMode = () => (
    <div className="glass-card">
      <h2 className="section-title">Mode Sommeil</h2>
      <div className="sleep-container">
        <div className="sleep-card">
          <div className="sleep-icon">🌙</div>
          <h3>Heure du coucher</h3>
          <input type="time" value={sleepTime} onChange={(e) => setSleepTime(e.target.value)} className="neon-input time-input" />
          <p className="sleep-message">⏰ Rappel a {sleepTime}</p>
          <p className="sleep-warning">"Time to rest. Avoid using your phone"</p>
        </div>
        {showSleepReminder && (
          <div className="sleep-alert">
            <p>🌙 Time to rest. Avoid using your phone. Good night!</p>
            <button onClick={() => setShowSleepReminder(false)}>Fermer</button>
          </div>
        )}
      </div>
    </div>
  );
  
  const renderProgress = () => (
    <div className="glass-card">
      <h2 className="section-title">Votre Progression</h2>
      <div className="stats-grid">
        <div className="stat-card"><span>✅</span><h3>{progressData.tasksCompleted}</h3><p>Taches</p></div>
        <div className="stat-card"><span>📚</span><h3>{progressData.studyHours}h</h3><p>Etude</p></div>
        <div className="stat-card"><span>🎯</span><h3>{progressData.focusSessions}</h3><p>Focus</p></div>
        <div className="stat-card"><span>🔥</span><h3>{streak}</h3><p>Jours</p></div>
        <div className="stat-card"><span>🏆</span><h3>{userLevel}</h3><p>Niveau</p></div>
        <div className="stat-card"><span>⭐</span><h3>{userXP}</h3><p>XP</p></div>
      </div>
    </div>
  );
  
  const renderAnalytics = () => (
    <div className="glass-card">
      <h2 className="section-title">Analytics</h2>
      <div className="analytics-grid">
        <div className="heatmap-section">
          <h3>Activite (30 jours)</h3>
          <div className="heatmap-grid">
            {[...Array(30)].map((_, i) => {
              const intensity = Math.random() > 0.7 ? 'high' : Math.random() > 0.4 ? 'medium' : 'low';
              return <div key={i} className={`heatmap-cell ${intensity}`}></div>;
            })}
          </div>
        </div>
        <div className="subjects-stats">
          <h3>Temps par matiere</h3>
          {Object.entries(studyTimeBySubject).length === 0 ? <p>Aucune donnee pour le moment</p> : Object.entries(studyTimeBySubject).map(([subject, hours]) => (
            <div key={subject} className="subject-bar"><span>{subject}</span><div className="bar-bg"><div className="bar-fill" style={{ width: `${Math.min((hours / 20) * 100, 100)}%` }}></div></div><span>{hours}h</span></div>
          ))}
        </div>
      </div>
    </div>
  );
  
  const renderResources = () => {
    const currentResources = resources[selectedSubject] || { cours: [{ name: `Cours ${selectedSubject}`, url: "#" }], exercices: [], livres: [], videos: [] };
    const resourceItems = currentResources[selectedResourceType] || [];
    
    return (
      <div className="glass-card">
        <h2 className="section-title">Ressources par matiere</h2>
        <div className="subject-selector">
          <label>Choisir une matiere :</label>
          <select value={selectedSubject} onChange={(e) => setSelectedSubject(e.target.value)} className="neon-select">
            {subjects.map(sub => <option key={sub} value={sub}>{sub}</option>)}
          </select>
        </div>
        <div className="resource-tabs">
          <button className={`resource-tab ${selectedResourceType === 'cours' ? 'active' : ''}`} onClick={() => setSelectedResourceType('cours')}>Cours</button>
          <button className={`resource-tab ${selectedResourceType === 'exercices' ? 'active' : ''}`} onClick={() => setSelectedResourceType('exercices')}>Exercices</button>
          <button className={`resource-tab ${selectedResourceType === 'livres' ? 'active' : ''}`} onClick={() => setSelectedResourceType('livres')}>Livres</button>
          <button className={`resource-tab ${selectedResourceType === 'videos' ? 'active' : ''}`} onClick={() => setSelectedResourceType('videos')}>Videos</button>
        </div>
        <div className="resources-list">
          {resourceItems.map((item, idx) => (
            <div key={idx} className="resource-item">
              <a href={item.url} target="_blank" rel="noopener noreferrer" className="resource-link">{item.name}</a>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  const renderNotes = () => (
    <div className="glass-card">
      <h2 className="section-title">Notes Rapides</h2>
      <div className="note-controls"><input type="text" placeholder="Rechercher..." value={noteSearch} onChange={(e) => setNoteSearch(e.target.value)} className="neon-input search-input" /></div>
      <div className="note-input-group">
        <input type="text" value={newNote} onChange={(e) => setNewNote(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && addNote()} placeholder="Nouvelle note..." className="neon-input" />
        <select value={noteCategory} onChange={(e) => setNoteCategory(e.target.value)} className="neon-select">
          <option value="Cours">Cours</option><option value="Idees">Idees</option><option value="Rappels">Rappels</option>
        </select>
        <button onClick={addNote} className="btn-primary">+</button>
      </div>
      <div className="notes-list">
        {notes.filter(n => n.text.toLowerCase().includes(noteSearch.toLowerCase())).map(note => (
          <div key={note.id} className="note-item">
            <span className="note-category">{note.category === 'Cours' ? '📚' : note.category === 'Idees' ? '💡' : '⏰'}</span>
            <span className="note-text">{note.text}</span>
            <button onClick={() => deleteNote(note.id)} className="delete-btn">🗑️</button>
          </div>
        ))}
      </div>
    </div>
  );
  
  const renderReminders = () => (
    <div className="glass-card">
      <h2 className="section-title">Pomodoro & Rappels</h2>
      <div className="pomodoro-section">
        <div className="pomodoro-timer-display"><div className="pomodoro-timer-circle"><span className="pomodoro-time">{formatTime(focusMode.timeLeft)}</span><span className="pomodoro-label">{focusMode.type === 'work' ? 'Session d\'etude' : focusMode.type === 'break' ? 'Pause courte' : 'Pause longue'}</span></div></div>
        <div className="pomodoro-controls"><button onClick={startFocus} className={`pomodoro-btn ${focusMode.active ? 'active' : ''}`}>{focusMode.active ? 'Pause' : 'Demarrer'}</button><button onClick={resetFocus} className="pomodoro-btn reset">Reinitialiser</button></div>
        <div className="pomodoro-tip"><span>💡</span><div><strong>Conseil Pomodoro :</strong><p>25 minutes de travail intense, 5 minutes de pause. Gagnez de l'XP a chaque session !</p></div></div>
      </div>
      <div className="reminders-section"><h3>Rappels programmes</h3><div className="reminder-inputs"><input type="text" placeholder="Titre du rappel" value={newReminder.title} onChange={(e) => setNewReminder({ ...newReminder, title: e.target.value })} className="neon-input" /><input type="time" value={newReminder.time} onChange={(e) => setNewReminder({ ...newReminder, time: e.target.value })} className="neon-input" /><button onClick={addReminder} className="btn-primary">+ Ajouter</button></div>
      <div className="reminders-list">{reminders.map(r => (<div key={r.id} className="reminder-item"><span>⏰ {r.time}</span><span>{r.title}</span><button onClick={() => deleteReminder(r.id)} className="delete-btn">🗑️</button></div>))}</div></div>
    </div>
  );
  
  const renderChallenges = () => (
    <div className="glass-card">
      <h2 className="section-title">Defis du Jour</h2>
      <p className="challenges-subtitle">Relevez ces defis pour gagner de l'XP et des badges !</p>
      <div className="challenges-grid">
        {dailyChallenges.map(challenge => (
          <div key={challenge.id} className={`challenge-card ${challenge.completed ? 'completed' : ''}`}>
            <div className="challenge-header"><span className="challenge-title">{challenge.title}</span>{challenge.completed && <span className="challenge-badge">+{challenge.xpReward} XP</span>}</div>
            <div className="challenge-progress"><div className="challenge-progress-bar"><div className="challenge-progress-fill" style={{ width: `${(challenge.progress / challenge.target) * 100}%` }}></div></div><span className="challenge-stats">{challenge.progress} / {challenge.target}</span></div>
          </div>
        ))}
      </div>
    </div>
  );
  
  const renderGoals = () => (
    <div className="glass-card">
      <h2 className="section-title">Objectifs</h2>
      <div className="goals-container">
        <div className="daily-goals"><h3>Objectifs journaliers</h3>
          <div className="goal-item"><span>Etude</span><div className="goal-progress"><div className="goal-fill" style={{ width: `${Math.min((progressData.studyHours / dailyGoals.studyHours) * 100, 100)}%` }}></div></div><span>{progressData.studyHours}/{dailyGoals.studyHours}h</span></div>
          <div className="goal-item"><span>Taches</span><div className="goal-progress"><div className="goal-fill" style={{ width: `${Math.min((progressData.tasksCompleted / dailyGoals.tasksCompleted) * 100, 100)}%` }}></div></div><span>{progressData.tasksCompleted}/{dailyGoals.tasksCompleted}</span></div>
        </div>
        <div className="weekly-goals"><h3>Objectifs hebdomadaires</h3>
          <div className="goal-item"><span>Etude</span><div className="goal-progress"><div className="goal-fill" style={{ width: `${goalProgress.study}%` }}></div></div><span>{progressData.studyHours}/{weeklyGoals.studyHours}h</span></div>
          <div className="goal-item"><span>Taches</span><div className="goal-progress"><div className="goal-fill" style={{ width: `${goalProgress.tasks}%` }}></div></div><span>{progressData.tasksCompleted}/{weeklyGoals.tasksCompleted}</span></div>
          <div className="goal-item"><span>Focus</span><div className="goal-progress"><div className="goal-fill" style={{ width: `${goalProgress.focus}%` }}></div></div><span>{progressData.focusSessions}/{weeklyGoals.focusSessions}</span></div>
        </div>
      </div>
    </div>
  );
  
  const renderProfile = () => (
    <div className="glass-card profile-container">
      <h2 className="section-title">Mon Profil</h2>
      <div className="profile-stats"><div className="profile-avatar">🎓</div><div className="profile-info"><div className="profile-level">Niveau {userLevel}</div><div className="profile-xp">{userXP} XP</div><div className="profile-coins">🪙 {coins} pieces</div><div className="profile-streak">🔥 {streak} jours consecutifs</div></div></div>
      <div className="profile-badges"><h3>Badges obtenus</h3><div className="badges-grid">{badges.length === 0 ? <p>Completez des defis pour gagner des badges !</p> : badges.map((badge, i) => (<div key={i} className="profile-badge">🏅 {badge.name}</div>))}</div></div>
    </div>
  );
  
  // Menu
  const menuItems = [
    { id: 'dashboard', icon: '📊', name: 'Dashboard' },
    { id: 'games', icon: '🎮', name: 'Mini-Jeux' },
    { id: 'tasks', icon: '📝', name: 'Taches' },
    { id: 'study', icon: '📚', name: 'Planning' },
    { id: 'reminders', icon: '⏰', name: 'Rappels' },
    { id: 'challenges', icon: '🏆', name: 'Defis' },
    { id: 'sleep', icon: '😴', name: 'Sommeil' },
    { id: 'progress', icon: '📈', name: 'Progres' },
    { id: 'analytics', icon: '📊', name: 'Analytics' },
    { id: 'resources', icon: '📚', name: 'Ressources' },
    { id: 'notes', icon: '📝', name: 'Notes' },
    { id: 'goals', icon: '🎯', name: 'Goals' },
    { id: 'profile', icon: '👤', name: 'Profil' }
  ];
  
  const renderContent = () => {
    switch(activeSection) {
      case 'dashboard': return renderDashboard();
      case 'games': return renderGames();
      case 'tasks': return renderTasks();
      case 'study': return renderStudyPlanner();
      case 'reminders': return renderReminders();
      case 'challenges': return renderChallenges();
      case 'sleep': return renderSleepMode();
      case 'progress': return renderProgress();
      case 'analytics': return renderAnalytics();
      case 'resources': return renderResources();
      case 'notes': return renderNotes();
      case 'goals': return renderGoals();
      case 'profile': return renderProfile();
      default: return renderDashboard();
    }
  };
  
  return (
    <div className="app">
      <div className="vibe-bg"></div>
      
      {confetti.map(c => (
        <div key={c.id} className="confetti-piece" style={{ position: 'fixed', left: c.x, top: c.y, fontSize: c.size, zIndex: 1000, pointerEvents: 'none' }}>
          {c.char}
        </div>
      ))}
      
      <audio ref={audioRef} loop src="https://cdn.pixabay.com/download/audio/2022/05/27/audio_1808fbf07a.mp3?filename=lofi-study-112191.mp3" />
      
      {showNotification.show && (
        <div className={`notification-bar ${showNotification.type}`}>
          <div className="notif-title">Smart Student Hub</div>
          <div className="notif-body">{showNotification.message}</div>
        </div>
      )}
      
      {/* ALERTE COMPTE A REBOURS POUR RAPPELS */}
      {countdownAlert.show && (
        <div className="countdown-alert-overlay">
          <div className="countdown-alert-card">
            <div className="countdown-alert-icon">🔔⏰🔔</div>
            <h2 className="countdown-alert-title">RAPPEL URGENT !</h2>
            <div className="countdown-alert-message">
              <span className="reminder-icon">📢</span>
              {countdownAlert.message}
            </div>
            <div className="countdown-alert-timer">
              <span className="timer-label">Temps restant</span>
              <span className="timer-value">{countdownAlert.seconds}s</span>
            </div>
            <div className="countdown-alert-buttons">
              <button className="countdown-alert-btn confirm" onClick={() => {
                setCountdownAlert({ show: false, message: '', seconds: 0 });
                if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
                addNotification('Rappel confirme ! Continuez vos etudes !', 'success');
                triggerConfetti();
              }}>J'AI COMPRIS</button>
              <button className="countdown-alert-btn snooze" onClick={() => snoozeReminder(countdownAlert.message)}>RAPPEL DANS 5 MIN</button>
            </div>
            <div className="countdown-alert-footer"><span>🔊 Sonnerie en cours...</span></div>
          </div>
        </div>
      )}
      
      <div className="dashboard">
        <aside className={`sidebar ${isSidebarCollapsed ? 'collapsed' : ''}`}>
          <div className="sidebar-header">
            <div className="logo"><span className="logo-icon">🎓</span>{!isSidebarCollapsed && <span className="logo-text">Smart Student Hub</span>}</div>
            <button className="collapse-btn" onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}>{isSidebarCollapsed ? '→' : '←'}</button>
          </div>
          
          <div className="user-level-card">
            <div className="level-icon">🏆</div>
            <div className="level-info"><div className="level-number">Niv.{userLevel}</div><div className="level-xp">{userXP} XP</div></div>
            <div className="level-progress-bar"><div className="level-progress-fill" style={{ width: `${(userXP % 100)}%` }}></div></div>
          </div>
          
          <nav className="sidebar-nav">
            {menuItems.map(item => (
              <div key={item.id} className={`sidebar-item ${activeSection === item.id ? 'active' : ''}`} onClick={() => setActiveSection(item.id)}>
                <span className="sidebar-icon">{item.icon}</span>
                {!isSidebarCollapsed && <span className="sidebar-name">{item.name}</span>}
              </div>
            ))}
          </nav>
          
          <div className="sidebar-footer">
            <button className={`music-btn-sidebar ${isMusicPlaying ? 'playing' : ''}`} onClick={toggleMusic}>
              <span>{isMusicPlaying ? '⏸️' : '🎵'}</span>
              {!isSidebarCollapsed && (isMusicPlaying ? 'Pause' : 'Lofi')}
            </button>
            <button className="party-btn-sidebar" onClick={triggerConfetti}>
              <span>✨</span>
              {!isSidebarCollapsed && 'Vibe'}
            </button>
          </div>
        </aside>
        
        <main className="main-content">
          <header className="main-header">
            <h1>{menuItems.find(i => i.id === activeSection)?.name || 'Dashboard'}</h1>
            <div className="user-stats">
              <div className="user-stat">🔥 {streak}</div>
              <div className="user-stat">🏆 Niv.{userLevel}</div>
              <div className="user-stat">⭐ {userXP} XP</div>
              <div className="user-stat">🪙 {coins}</div>
            </div>
          </header>
          <div className="content-area">{renderContent()}</div>
        </main>
      </div>
    </div>
  );
};

export default App;